import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Grid.module.scss';

const Grid = ({ children, isB2B, isHeaderSticky, isMenuOpened }) => {
  const rootClassName = cn(styles.root, {
    [styles.rootSticky]: isHeaderSticky,
    [styles.isMenuOpened]: isMenuOpened,
    [styles.rootDesktop]: !isB2B,
    [styles.rootB2BDesktop]: isB2B,
  });
  return <div className={rootClassName}>{children(styles)}</div>;
};

Grid.propTypes = {
  children: PropTypes.func.isRequired,
  isHeaderSticky: PropTypes.bool,
  isB2B: PropTypes.bool,
  isMenuOpened: PropTypes.bool,
};

Grid.defaultProps = {
  isB2B: false,
  isHeaderSticky: false,
  isMenuOpened: false,
};

Grid.displayName = 'Grid';

export default Grid;
